const firstNameRules = [
  {
    feedback: 'First name is required',
    test(value) {
      return !!value;
    },
  },
];

export default firstNameRules;
